/*eslint-disable */

let $ = window.jQuery;

$(document).ready(function () {
	/**
     * Allow any sub menus to be toggled on mobiles.
     */
    function touchDropdowns() {
      var nav, itemHasChildren;

      nav = $('#c-navigation');
      itemHasChildren = $('#c-navigation .menu__item--has-children');

      itemHasChildren.children('a').on('click', function(event) {
        var width, item;

        width = (window.innerWidth !== undefined) ? window.innerWidth : document.documentElement.clientWidth;
        item = $(this).parent();

        if (!item.hasClass('active') && width <= 1024) {
          event.preventDefault();
          nav.find('.active').removeClass('active').find('.sub-menu').stop().slideUp(350);
          item.addClass('active');
          item.find('.sub-menu').stop().slideToggle(350);
        }
      });
    };

    touchDropdowns();
});

/*eslint-ensable */
